import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Avatar, Button, Dropdown, Layout, Progress, Tooltip} from 'antd';
import IconEn from '@/assets/icons/ic_en.svg';
import IconJp from '@/assets/icons/ic_jp.svg';
import i18n, {i18nKey} from '@/locales/i18n';
import {MenuInfo} from 'rc-menu/lib/interface';
import {UserOutlined} from '@ant-design/icons';
import {IResponseGetUsageCurrent} from '@/types';
// import IcNotification from '@/assets/icons/ic_notification.svg';
import {ReactComponent as Logo} from '@/assets/icons/logo.svg';
import IconBtnMenuLeft from '@/assets/icons/ic_btn_menu_left.svg';
import {
  ITEM_INFO,
  ITEM_KEY_INFO,
  ITEM_LANGUAGE,
  PAGE_LIMIT_DEFAULT,
  PAGE_USED_PERCENT,
  PageRoute,
  ROLE,
} from '@/constants';
import styles from './HeaderLayout.module.scss';

const {Header} = Layout;
// const {Item} = Form;

interface HeaderLayoutProps {
  nameInfo?: string;
  onInfoChange?: (e: MenuInfo) => void;
  roleId?: number;
  usageCurrent?: IResponseGetUsageCurrent;
  isCollapse?: boolean;
  toggleMenu?: () => void;
}

const HeaderLayout = ({
  nameInfo,
  onInfoChange,
  usageCurrent,
  roleId,
  isCollapse,
  toggleMenu,
}: HeaderLayoutProps) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <Header className={styles.headerLayout}>
      <div className={styles.headerWrapper}>
        <div className={styles.headerContainer}>
          <div className={styles.headerGroupMenu}>
            <div className={styles.headerGroupMenuLeft}>
              <Logo
                className={styles.logo}
                onClick={() => navigate(PageRoute.HOME)}
              />
            </div>
            <Button
              type="link"
              className={styles.buttonAction}
              style={{transform: isCollapse ? 'rotate(180deg)' : ''}}
              onClick={toggleMenu}
            >
              <img src={IconBtnMenuLeft} />
            </Button>
          </div>
          {/* <Form layout="inline" className={styles.form}>
            <Item>
              <Input placeholder="Search" className={styles.input} />
            </Item>
          </Form> */}
        </div>
        <div className={styles.headerGroupSetting}>
          {roleId !== ROLE.PARTNER && (
            <Tooltip
              overlayClassName={styles.toolTipHeaderCustom}
              title={
                <div className={styles.wrapperToolTip}>
                  <div className={styles.title}>
                    {t(i18nKey.header.usage.pageUsed)}
                  </div>
                  <div className={styles.contentWrapper}>
                    <div className={styles.numberPageUser}>
                      {usageCurrent?.pageUsed}
                    </div>
                    <div className={styles.period}>/</div>
                    <div className={styles.totalBlocks}>
                      {(usageCurrent?.totalBlockRegistered ?? 0) *
                        PAGE_LIMIT_DEFAULT}
                    </div>
                    <div className={styles.titleMonth}>
                      {' '}
                      {t(i18nKey.header.usage.thisMonth)}
                    </div>
                  </div>
                </div>
              }
              arrow={false}
              placement="bottomRight"
            >
              <Progress
                className={styles.customProgressBar}
                size={52}
                type="circle"
                format={() =>
                  `${parseFloat(
                    (
                      ((usageCurrent?.pageUsed ?? 0) /
                        ((usageCurrent?.totalBlockRegistered ?? 0) *
                          PAGE_LIMIT_DEFAULT)) *
                      PAGE_USED_PERCENT
                    ).toFixed(1),
                  )}%`
                }
                percent={
                  ((usageCurrent?.pageUsed ?? 0) /
                    ((usageCurrent?.totalBlockRegistered ?? 0) *
                      PAGE_LIMIT_DEFAULT)) *
                  PAGE_USED_PERCENT
                }
                strokeWidth={8}
                strokeColor={{
                  '10%': '#352FED',
                  '90%': '#A386FC ',
                }}
              />
            </Tooltip>
          )}
          <div className={styles.headerSettingConfig}>
            {/* <img src={IcNotification} alt="IcNotification" /> */}
            <Dropdown
              placement="bottomRight"
              arrow={{pointAtCenter: true}}
              menu={{
                selectable: true,
                selectedKeys: [i18n.resolvedLanguage?.toString() ?? 'en'],
                defaultSelectedKeys: ['en'],
                onClick: async (e) => {
                  await i18n.changeLanguage(e.key);
                },
                items: ITEM_LANGUAGE.map((i) => {
                  return {
                    ...i,
                    label: i.label(),
                  };
                }),
              }}
              trigger={['click']}
            >
              <img
                width={20}
                height={15}
                src={
                  i18n.resolvedLanguage === ITEM_KEY_INFO.EN ? IconEn : IconJp
                }
                alt="Icon Country"
              />
            </Dropdown>
          </div>
          <div className={styles.headerSettingInfo}>
            <span>{nameInfo}</span>
            <Dropdown
              placement="bottomRight"
              arrow={{pointAtCenter: true}}
              menu={{
                onClick: onInfoChange,
                items: ITEM_INFO.map((i) => {
                  return {
                    ...i,
                    label: i.label(),
                  };
                }),
              }}
              trigger={['click']}
            >
              <Avatar shape="circle" size={40} icon={<UserOutlined />} />
            </Dropdown>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default HeaderLayout;
